import { IStargateClient, StargateClient } from './client';
import React, { createContext, PropsWithChildren, useContext } from 'react';

export const DEFAULT_BASE_URL = 'https://api.stg.atlassian.com';

const StargateClientContext = createContext<IStargateClient>(
  new StargateClient({
    baseUrl: DEFAULT_BASE_URL
  })
);

export function useStargateClient(): IStargateClient {
  return useContext(StargateClientContext);
}

export type StargateClientProviderProps = {
  readonly client: IStargateClient;
};

export function StargateClientProvider(
  props: PropsWithChildren<StargateClientProviderProps>
) {
  const { children } = props;
  return (
    <StargateClientContext.Provider value={props.client}>
      {children}
    </StargateClientContext.Provider>
  );
}
